var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag",class:{
        'tag--not-valid': !_vm.isValid,
        'tag--focused': _vm.isFocused,
    },on:{"click":_vm.handleClick}},[_c('input',{ref:"email",attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.handleChange,"blur":_vm.handleBlur,"focus":_vm.handleFocus}}),_c('button',{staticClass:"close btn",on:{"click":_vm.handleClose}},[_c('i',{staticClass:"icon-X-01"})])])}
var staticRenderFns = []

export { render, staticRenderFns }